import {
  apiClient,
  Auth,
  Pagination,
  PaginationSearchParams,
} from '@/shared/api'

import {
  MasterContractStatus,
  TGuestMasterContract,
  SortOption,
} from '../model/schema'

export type GuestMasterContractsSearchParams = Pick<
  PaginationSearchParams,
  'page'
> & {
  contractMasterStatus?: MasterContractStatus
  sortBy?: SortOption
}

export const getGuestMasterContracts = async (
  params: GuestMasterContractsSearchParams,
) => {
  const { data } = await apiClient.get<Pagination<TGuestMasterContract>>({
    endpoint: `/guest/contracts/masters`,
    queryParams: {
      ...params,
      size: 10,
    },
    auth: Auth.REQUIRED,
  })

  return data
}
